import * as actionTypes from "./types";

export const updateRestData = (data) => ({
  type: actionTypes.UPDATE_REST_DATA,
  payload: data,
});

export const updateTableData = (data) => ({
  type: actionTypes.UPDATE_TABLE_DATA,
  payload: data,
});

export const updateCategoryList = (data) => ({
  type: actionTypes.UPDATE_CATEGORY_LIST,
  payload: data,
});

export const updateMenuList = (data) => ({
  type: actionTypes.UPDATE_MENU_LIST,
  payload: data,
});

export const updateModelList = (data) => ({
  type: actionTypes.UPDATE_MODEL_LIST,
  payload: data,
});

export const updateCourseList = (data) => ({
  type: actionTypes.UPDATE_COURSE_LIST,
  payload: data,
});

export const updateGroupSession = (sessionId) => {
  return {
    type: actionTypes.UPDATE_GROUP_SESSION,
    payload: sessionId
  };
};

export const updateDiscountList = (data) => ({
  type: actionTypes.UPDATE_DISCOUNT_LIST,
  payload: data,
});

export const updateAllergenList = (allergenList) => ({
  type: actionTypes.UPDATE_ALLERGEN_LIST,
  payload: allergenList
});

export const updateMenuAttributes = (menuAttributesList) => ({
  type: actionTypes.UPDATE_MENU_ATTRIBUTES,
  payload: menuAttributesList
})
